import { connect } from 'react-redux';
import { setActiveStep } from '../../state/enrollment/enrollmentActions';
import {
  getActiveStep,
  getActiveStepIndex,
  getEnrollmentSteps,
} from '../../state/enrollment/enrollmentSelectors';
import { ApplicationState } from '../../state/store';
import Enrollment from './Enrollment';

const mapStateToProps = (state: ApplicationState) => ({
  enrollmentSteps: getEnrollmentSteps(state),
  activeStep: getActiveStep(state),
  activeStepIndex: getActiveStepIndex(state),
});

const mapDispatchToProps = {
  setActiveStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(Enrollment);
